import { getFilmAvailability } from '../../browsing/selectors/films/get-film-availability';
import { hasValidValuesForFilter } from './has-valid-values-for-filter';
// Note: Filtering is done by AND operation between the filter types, and the OR operation between the filter options within a filter type.
// i.e if genre=['Comedy', 'Action'] and attribute=['IMAX'], the results would be films that satisfy ('Comedy' || 'Action') && ('IMAX')
// For fixed filtering, apply the AND operation. e.g. for IMAX fixed filter, ('Comedy') && ('IMAX' && ('CC', '3D')).
export const filterFilms = (filter, allFilms) => {
    return allFilms.filter(film => {
        const filmAvailability = getFilmAvailability(film.id, filter.siteId);
        if (!filmAvailability)
            throw new Error(`Cannot find film availability with filmId: ${film.id}.`);
        return (hasValidValuesForFilter(filter.sections.category, filmAvailability.categories) &&
            hasValidValuesForFilter(filter.sections.genre, film.genreIds) &&
            hasValidValuesForFilter(filter.sections.attribute, filmAvailability.showtimeAttributeIds) &&
            hasValidValuesForFilter(filter.sections.event, film.eventId ? [film.eventId] : []));
    });
};
